import gql from 'graphql-tag'

export const usersQuery = gql`
  query ($orderBy: UserOrderByInput, $first: Int, $after: ID) {
    users (orderBy: $orderBy, first: $first, after: $after) {
      id
      name
      email
      cognitoUsername
      isAdmin
    }
  }
`

export const deleteUserMutation = gql`
  mutation ($id: ID!) {
    deleteUser (id: $id) {
      id
    }
  }
`

export const resetUserPasswordMutation = gql`
  mutation ($id: ID!) {
    resetUserPassword (id: $id)
  }
`

export const setAdminMutation = gql`
  mutation ($id: ID!, $isAdmin: Boolean!) {
    setAdmin (id: $id, isAdmin: $isAdmin) {
      id
      name
      email
      cognitoUsername
      isAdmin
    }
  }
`

export const sendUserInvite = gql`
  mutation ($trainerId: ID, $name: String, $email: String, $isAdmin: Boolean) {
    sendUserInvite (trainerId: $trainerId, name: $name, email: $email, isAdmin: $isAdmin) {
      id
      expiresAt
    }
  }
`

export const validateUserInviteQuery = gql`
  query ($token: String!) {
    validateUserInvite(token: $token) {
      id
      name
      email
      trainer {
        id
      }
    }
  }
`

export const acceptUserInviteMutation = gql`
  mutation ($token: String!, $email: String!, $cognitoUsername: String!) {
    acceptUserInvite(token: $token, email: $email, cognitoUsername: $cognitoUsername) {
      id
    }
  }
`
